module.exports = __webpack_public_path__ + "static/media/profitFlowMockups.de7a7777.png";